import React from 'react';
import { gridConnectionDetailsRoute } from '@/modules/charge-center/grid-connections/grid-connection-details/route';
import { createRoute } from '@tanstack/react-router';

// ! This should be a different component than the one used in ALL charge points
export const gridConnectionChargePointsRoute = createRoute({
  getParentRoute: () => gridConnectionDetailsRoute,
  path: 'charge-points',
  component: React.lazy(async () => await import('@/app/routes/ChargeCenter/ChargePointTab')),
  wrapInSuspense: true,
});
